import { flattenDeep, get } from 'lodash';
import { EventService } from './../../services/event-service/event.service';
import { GrayoutService } from './../../quick-quote/services/grayout.service';
import { QUICK_QUOTE_CONSTANTS } from './../../quick-quote/quick-quote.constants';
import { QuickQuoteService } from './../../quick-quote/services/quick-quote.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/event-service/event.service";
import * as i2 from "../../quick-quote/services/grayout.service";
import * as i3 from "../../quick-quote/services/quick-quote.service";
var ContextualFilterService = /** @class */ (function () {
    function ContextualFilterService(eventService, grayoutService, quickQuoteService) {
        this.eventService = eventService;
        this.grayoutService = grayoutService;
        this.quickQuoteService = quickQuoteService;
        this.quickQuoteConstants = QUICK_QUOTE_CONSTANTS;
    }
    /**
     * Subscribe at eventService in order to get a filter optionGroup from quick quote service
     */
    ContextualFilterService.prototype.subscribeFilterOptionGroup = function () {
        this.eventService.sendNextItem({
            name: this.contextualFilterType,
            value: this.quickQuoteService.getOptionGroupFiltersByType(this.contextualFilterType)
        });
    };
    /**
     * Get the optionGroup observable from eventService
     * @returns observable of the optionGroupFilter
     */
    ContextualFilterService.prototype.getOptionGroupFiltersByType = function () {
        return this.eventService.getSubject(this.contextualFilterType);
    };
    /**
     * Call all the processes needed for the current selected filter in order to define its state
     * @param filterOptionItem filter selected to be modified
     * @param filtersApplied current filters applied
     */
    ContextualFilterService.prototype.filterOptionItemChanged = function (filterOptionItem, filtersApplied, action) {
        this.grayoutService.checkGrayout();
        this.addOrRemoveFilterOption(filterOptionItem, filtersApplied, action);
        this.quickQuoteService.mergeIntoSelectedFilters();
        this.quickQuoteService.updateCookieValueFromSelectedFilters();
        this.quickQuoteService.updateURLFromCookieValue();
    };
    /**
     * Modify the filter selected according to the action made by user add/remove
     * @param filterOptionItem - filter to be modified
     * @param filtersApplied - current filters applied
     * @param action - Action applied from a particular featured cruise option
     */
    ContextualFilterService.prototype.addOrRemoveFilterOption = function (filterOptionItem, filtersApplied, action) {
        var actionType = get(action, 'type');
        var itemFilterChange = {
            filterType: this.getFilterType(action, actionType) || this.quickQuoteConstants.filters['more-filters'].id,
            groupType: actionType || this.contextualFilterType,
            id: filterOptionItem.id,
            isSelected: filterOptionItem.selected,
            urlFriendlyId: filterOptionItem.urlFriendlyId
        };
        // each filter in the array has a different model that's the why it cant be typed with any specific type
        var temporalFilterSelected = flattenDeep(this.quickQuoteService.getTempFiltersSelected())
            .find(function (filter) { return filter.urlFriendlyId === itemFilterChange.urlFriendlyId; });
        var appliedFilter = this.quickQuoteService.getSelectedFilterByID(itemFilterChange, filtersApplied);
        if (temporalFilterSelected && !appliedFilter) {
            filterOptionItem.selected = true;
            itemFilterChange.isSelected = true;
            this.quickQuoteService.updateFilterLabelValuesFromSelectedFilters(this.quickQuoteService.getTempFiltersSelected());
        }
        else if (!temporalFilterSelected && appliedFilter) {
            filterOptionItem.selected = false;
            itemFilterChange.isSelected = false;
            this.quickQuoteService.changedFilterItem(itemFilterChange);
        }
        else {
            filterOptionItem.selected = !filterOptionItem.selected;
            itemFilterChange.isSelected = filterOptionItem.selected;
            this.quickQuoteService.changedFilterItem(itemFilterChange);
        }
    };
    /**
     * Gets filter type from group keys
     * @param actionFilter - Featured cruise action filter analyzed
     * @param actionType - Featured cruise action type analyzed
     * @returns Filter type
     */
    ContextualFilterService.prototype.getFilterType = function (actionFilter, actionType) {
        var moreFiltersGroup = this.quickQuoteConstants.filters['more-filters'];
        var nightGroupKey = actionType === moreFiltersGroup.groupKey.night;
        var themeGroupKey = actionType === moreFiltersGroup.groupKey.theme;
        var filterType = null;
        if (nightGroupKey || themeGroupKey) {
            filterType = moreFiltersGroup.id;
        }
        else if (actionFilter) {
            filterType = actionFilter.type;
        }
        return filterType;
    };
    ContextualFilterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContextualFilterService_Factory() { return new ContextualFilterService(i0.ɵɵinject(i1.EventService), i0.ɵɵinject(i2.GrayoutService), i0.ɵɵinject(i3.QuickQuoteService)); }, token: ContextualFilterService, providedIn: "root" });
    return ContextualFilterService;
}());
export { ContextualFilterService };
